import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BreakPoint, Color, FontSize } from '../styles/constants';

const Btn = styled.button`
  background-color: ${props =>
    props.primary === true ? Color.red : Color.white};
  border: solid 1px
    ${props => (props.primary === true ? Color.red : Color.border.darkGray)};
  border-radius: 4px;
  color: ${props =>
    props.primary === true ? Color.text.white : Color.text.gray};
  cursor: pointer;
  font-size: ${FontSize.medium};
  padding: 7px 0;
  width: 100%;

  @media (min-width: ${BreakPoint.desktop}) {
    font-size: ${FontSize.desktop.medium};
  }
`;

const Button = props => (
  <Btn type="button" onClick={props.onClick} primary={props.primary}>
    {props.children}
  </Btn>
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  primary: PropTypes.bool,
};

Button.defaultProps = {
  onClick: () => {},
  primary: undefined,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/subComponents/Button.jsx